<template>
  <TheGreyWrapper v-if="opportunity">
    <TheHeader
      back-route="new"
      force-sm-style
    />
    <BaseSection>
      <BaseTitleGroup
        v-if="opportunity"
        :subtitle="opportunity.data.attributes.name"
        :title="$t('Confirm your wish')"
        class="mb-4"
      />
      <BaseParagraph class="text-grey">
        {{ $t('You want to invest') }} :
      </BaseParagraph>
      <div class="big-number relative">
        {{ wishAmount | currency({ fractionCount: 0, symbol: '' }) }}
        <span class="ml-2 euro-sign absolute font-sans-medium text-2xl">€</span>
      </div>
      <BaseWarningBox class="mb-2">
        <span class="text-black font-heavy">{{ $t('Important') }} :</span>
        {{ $t('Capital risk warning') }}
        <span class="text-black">"{{ $t('Kerala Analysis') }}"</span>
        <br>
        <br>
        {{ $t('We are available') }}
      </BaseWarningBox>
      <BaseButton
        title="Confirmer"
        class="md:mb-12"
        @click.native="sendWish"
      />
    </BaseSection>
  </TheGreyWrapper>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import loadOpportunity from '../mixins/loadOpportunity';
import TheHeader from '../components/TheHeader.vue';
import BaseSection from '../components/BaseSection.vue';
import BaseTitleGroup from '../components/BaseTitleGroup.vue';
import BaseParagraph from '../components/BaseParagraph.vue';
import BaseButton from '../components/BaseButton.vue';
import BaseWarningBox from '../components/BaseWarningBox.vue';
import TheGreyWrapper from '../components/TheGreyWrapper.vue';
import { VALIDATED_WISH_AMOUNT } from '../analytics';
import { SET_ALERT } from '../store/mutation-types';

export default {
  name: 'WishValidation',
  components: {
    TheHeader,
    BaseSection,
    BaseTitleGroup,
    BaseParagraph,
    BaseButton,
    TheGreyWrapper,
    BaseWarningBox,
  },
  mixins: [loadOpportunity],
  computed: {
    ...mapState('opportunity', ['wishAmount']),
    opportunityId() {
      return this.$route.params.id;
    },
  },
  created() {
    if (!this.wishAmount) {
      this.$router.push('new');
    }
  },
  methods: mapActions({
    sendWish() {
      this.$store.dispatch('opportunity/sendWish').then(() => {
        this.$router.push('confirmation');
      }).catch((error) => {
        if (error.response && error.response.status === 422) {
          this.$store.commit(SET_ALERT, 'Un souhait a déjà été émis pour cette opportunité');
        }
      });
      analytics.track(VALIDATED_WISH_AMOUNT);
    },
  }),
};
</script>

<style lang="css" scoped>
.big-number {
  font-size: 54px;
  height: 74px;
}
.euro-sign {
  top: 9px;
}
</style>
